export const baseURL = "https://carrentalgardenos.com";
export const baseURLWithoutPort = "https://carrentalgardenos.com";

export const languageApi = {
  getAllLanguages: baseURL + "/getLanguages",
};
export const keysApi = {
  getAllKeys: baseURL + "/settings/findAllByKeys",
};
export const locationsApi = {
  getAllLocation: baseURL + "/location/get/all",
};
export const siteValuesApi = {
  getAllValues: baseURL + "/site-values/findAllByKeys",
};
export const staticArticlesApi = {
  getAllValues: baseURL + "/staticarticles/find/byNames",
};
export const carsApi = {
  getAllCars: baseURL + "/vehicles/find/all",
};
export const emailApi = {
  sendEmail: baseURL + "/contact/create/email",
};
export const insurancesApi = {
  getAll: baseURL + "/insurance/get/all",
};
export const extrasApi = {
  getAll: baseURL + "/extras/get/available",
};
export const reservationApi = {
  post: baseURL + "/reservation/create",
};
export const searchApi = {
  post: (start, end) =>
    `${baseURL}/vehicles/find/availableByDate?pickUpDate=${start}&dropOffDate=${end}`,
};
